import { P, paletteHelper, typographyHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import type { DefaultTheme } from 'styled-components';
import styled from 'styled-components';

export interface TextWithStyles {
  text: string;
  bold?: boolean | null;
}

const StyledSpan = styled.span<{
  $variant?: keyof DefaultTheme['typography'];
  $colorVariant?: keyof DefaultTheme['palette'];
  $bold?: boolean;
}>`
  ${(props) => typographyHelper(props.$variant || 'body01')}
  color: ${(props) => paletteHelper(props.$colorVariant || 'textPrimary')};
  display: inline;

  ${(props) =>
    props.$bold &&
    `
    font-weight: 600;
  `}
`;

interface DynamicTextProps {
  dynamicTexts: TextWithStyles[];
  variant?: keyof DefaultTheme['typography'];
  variantBold?: keyof DefaultTheme['typography'];
  colorVariant?: keyof DefaultTheme['palette'];
  colorVariantBold?: keyof DefaultTheme['palette'];
  className?: string;
}

export const DynamicText: FunctionComponent<DynamicTextProps> = ({
  dynamicTexts,
  variant,
  variantBold,
  colorVariant,
  colorVariantBold,
  className,
}) => {
  return (
    <P className={className}>
      {dynamicTexts.map((dynamicText) => {
        if (dynamicText.bold)
          return (
            <StyledSpan
              key={dynamicText.text}
              $variant={variantBold}
              $colorVariant={colorVariantBold}
              $bold={true}
            >
              {dynamicText.text}
            </StyledSpan>
          );
        return (
          <StyledSpan key={dynamicText.text} $variant={variant} $colorVariant={colorVariant}>
            {dynamicText.text}
          </StyledSpan>
        );
      })}
    </P>
  );
};
